/* eslint-disable import/no-cycle */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import './card.scss';
import '../../constants/_global.scss';
import { CardInterface } from './cardTypes';
import FavoriteButton from '../favoriteButton/favoriteButtonComponent';
import { CustomH2, CustomH3 } from '../customText/customText';
import EditButton from '../editButton/editButtonComponent';
import { EDIT_BUTTON_TYPE } from '../editButton/editButtonTypes';
import { useSelector } from '../..';

const Card: React.FC<CardInterface> = ({
  name,
  adress,
  price,
  photo,
  onFavorite,
  onEdit,
  onClick,
  isOwner,
  alreadyFavorite,
  maxWidth,
  data,
  favoriteVisible,
}) => {
  const isLogin = useSelector((state) => state.userData.isLogin);

  const formatNumber = (num: number) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  const handleCardClick = () => {
    onClick(data.id);
  };

  const handleFavoriteClick = () => {
    if (isOwner) {
      onEdit(data.id);
    } else {
      onFavorite(data.id);
    }
  };

  const photoSrc = () => {
    if (typeof photo === 'string') {
      return photo;
    }
    return 'notstirng';
  };

  const width = {
    maxWidth: maxWidth ? `${maxWidth}px` : '425px',
  };

  const disabledFavorite = () => {
    if (favoriteVisible === false) {
      return favoriteVisible;
    }
    return isLogin;
  };

  return (
    <div className="card" onClick={handleCardClick} style={width}>
      <img src={photoSrc()} alt={name} className="picture" />
      <div className="description">
        <div className="about">
          <CustomH2 text={name} />
          <CustomH3 text={adress} />
        </div>
        <div className="price">
          <CustomH2 text={`${formatNumber(price)} ₽`} />
          {isOwner ? (
            <EditButton
              onClick={handleFavoriteClick}
              ver={EDIT_BUTTON_TYPE.PRIMARY}
              animation
            />
          ) : (
            <FavoriteButton
              onClick={handleFavoriteClick}
              alreadyFavorite={alreadyFavorite || false}
              disabledStatus={disabledFavorite()}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default Card;
